import { adminAdd } from "@ttp/goods/models/firestoreDoc/adminAdd";
import { clientAdd } from "@ttp/goods/models/firestoreDoc/clientAdd";

export const firestoreDoc = {
  adminAdd,
  clientAdd,
};
